export const steps = [
    {
        label: "1. Power on Gateway",
        title: "Power on Gateway",
        content:
            "Plug the BDG-256 into a wall outlet using the terminals on the left side of the unit (L1 and L2).",
        image:
            "https://images.unsplash.com/photo-1612835362596-4b7b7b0b4b0b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c29sYXIlMjBnYXRld2F5JTIwZ2F0ZXdheSUyMHNpdGV8ZW58MHx8MHx8&ixlib=rb-1.2.1&w=1000&q=80",
    },
    {
        label: "2. Pair Wi-Fi Booster",
        title: "Pair BDM Wi-Fi Booster with BDG-256 Gateway",
        content:
            "Press “WPS” buttons on both devices at the same time. Release the button and wait up to 1 minute until they are paired.  a. Plug Wi-Fi Booster into a wall outlet within 5ft of the home Wi-Fi router b. Navigate to the screen with WPS button (tbd) c. Press the WPS button on both devices at the same time and hold (??) d. After 1 minute, if the pairing is successful, the screen message “XXXX” appears and the gateway WPS light will become solid.Troubleshooting: If pairing fails, repeat steps a-d or call Tech Support at XXX)",
        image: "https://i.imgur.com/4M7IWwP.png",
    },
    {
        label: "3. Connect Home Router",
        title: "Connect the BDM Wi-Fi Booster with the Home Router",
        content:
            "Using the CAT-5 Ethernet cable, connect the BDM Wi-Fi Booster to the home router.",
        image: "https://i.imgur.com/4M7IWwP.png",
    },
    {
        label: "4. Test Wi-Fi Connection",
        title: "Test the Wi-Fi Connection",
        content:
            "Navigate through “Settings” to “Network Test”. Then click on “Excecute”. If the “Net State” shows “Good”, then the gateway has connected to the internet.  Troubleshooting: If the network status is not “Good”,check/resest the home Wi-Fi connection. Ensure the gateway is paired with the Wi-Fi Booster and the home Wi-Fi router is producing a signal.)",
        image: "https://i.imgur.com/4M7IWwP.png",
    },
    {
        label: "5. Register Microinverter",
        title: "Register the Microinverter",
        content:
            "Scan the barcodes located on the XXXX side of each microinverter. The serial numbers will populate the fields? ",
        image: "https://i.imgur.com/4M7IWwP.png",
    },
    {
        label: "6. Verify status",
        title: "Validate the status of each microinverter.",
        content: "",
    },
];